import { CurrencyText, TranslatedText } from "@/components/common/text";
import { ConfidenceLevel } from "@/components/common/svgs/ConfidenceLevel";

export const HoverPopup = ({ outbound }) => {
    const { marketName, rpm, rate, confidence, distance } = outbound;

    return (
        <div className="font-sans flex flex-col rounded py-2 px-3 bg-cm-p-surface min-w-[218px] min-h-[62px] border border-cm-p-outline drop-shadow-[0_2px_4px_rgba(0,0,0,0.08)] text-sm/[22px]">
            <div className="flex flex-row gap-4 items-center justify-between">
                <div className="text-cm-p-text-primary">{marketName} market</div>
                {distance ? <div className="text-cm-p-text-secondary text-right">{Math.round(distance)} miles</div> : null}
            </div>
            <div className="flex flex-row gap-4 items-center justify-between w-full">
                <div className="flex flex-row gap-3 items-center justify-between text-cm-p-text-primary font-semibold">
                    {rate || rpm ? (
                        <>
                            {rate ? (
                                <>
                                    <CurrencyText num={rate} round className="text-cm-p-text-primary text-sm/[22px]" canBeZero />
                                    {rpm ? <div className="h-3 w-[1px] bg-cm-p-outline" /> : null}
                                </>
                            ) : null}
                            {rpm ? <CurrencyText num={rpm} className="text-cm-p-text-primary text-sm/[22px]" canBeZero /> : null}
                        </>
                    ) : (
                        <div className="text-cm-p-text-primary text-sm/[22px]">
                            <TranslatedText text="No info" />
                        </div>
                    )}
                </div>
                <div className="flex items-center">
                    {confidence && confidence !== "no_data" ? (
                        <ConfidenceLevel level={confidence === "high" ? 3 : confidence === "medium" ? 2 : 1} />
                    ) : null}
                </div>
            </div>
        </div>
    );
};
